(function (window) {
  var CF_CONFIG = {
    readyWorkingDays: [1, 2, 3, 4, 5],
    readyRange: { min: 0, max: 2 },

    deliveryWorkingDays: [1, 2, 3, 4, 5, 6],
    deliveryRange: { min: 2, max: 5 },

    cutoffHour: 21,
    cutoffMinute: 0,
    cutoffEnabled: true,

    calculationMode: 'maxPreparation',

    dateFormat: 'numeric',

    holidays: [
      { date: '01-01', countries: ['AT', 'DE'] },
      { date: '01-06', countries: ['AT'] },
      { date: '05-01', countries: ['AT', 'DE'] },
      { date: '08-15', countries: ['AT'] },
      { date: '12-25', countries: ['AT', 'DE'] },
      { date: '12-26', countries: ['AT', 'DE'] },
      { date: '10-03', countries: ['DE'] },
      { date: '08-08', countries: ['DE'] },
      { date: '10-31', countries: ['DE'] },
      { date: '10-26', countries: ['AT'] },
      { date: '11-01', countries: ['AT', 'DE'] },
      { date: '12-08', countries: ['AT'] }
    ],

    messageTemplate:
      'Produktion und Lieferung ca. 5 - 7 Werktage. Geschätztes Lieferdatum: <strong>{min}</strong> - <strong>{max}</strong>',

    cartMessageTemplate:
      'Geschätztes Lieferdatum: <strong>{min}</strong> - <strong>{max}</strong>',

    cartAttributeKey: 'Geschätztes Lieferdatum'
  };

  var CF_HOLIDAY_SOURCE = {
    countries: ['AT', 'DE'],
    cacheKey: 'cf_holidays_cache_v3',
    cacheMaxAgeMs: 1000 * 60 * 60 * 24 * 30
  };

  var dynamicHolidays = null;

  var WEEKDAYS_LONG = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var WEEKDAYS_SHORT = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var MONTHS_LONG = [
    'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
  ];

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function easterSunday(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }

  function addDays(date, days) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  function toIso(date) {
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  }

  function movableHolidaysForYear(year) {
    var easter = easterSunday(year);
    return [
      { date: toIso(addDays(easter, -2)), countries: ['DE'] },
      { date: toIso(addDays(easter, 1)), countries: ['AT', 'DE'] },
      { date: toIso(addDays(easter, 39)), countries: ['AT', 'DE'] },
      { date: toIso(addDays(easter, 50)), countries: ['AT', 'DE'] },
      { date: toIso(addDays(easter, 60)), countries: ['AT'] }
    ];
  }

  function currentCacheKey() {
    return CF_HOLIDAY_SOURCE.cacheKey + '_' + CF_HOLIDAY_SOURCE.countries.slice().sort().join('-');
  }

  function loadCachedHolidays() {
    try {
      var raw = localStorage.getItem(currentCacheKey());
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed.fetchedAt || (Date.now() - parsed.fetchedAt) > CF_HOLIDAY_SOURCE.cacheMaxAgeMs) {
        return null;
      }
      return parsed.dates || null;
    } catch (e) {
      return null;
    }
  }

  function saveCachedHolidays(dates) {
    try {
      localStorage.setItem(currentCacheKey(), JSON.stringify({ fetchedAt: Date.now(), dates: dates }));
    } catch (e) {
    }
  }

  function fetchHolidaysForYear(year) {
    var requests = CF_HOLIDAY_SOURCE.countries.map(function (cc) {
      return fetch('https://nagerholidays.com/api/v4/Holidays/' + cc + '/' + year)
        .then(function (r) { return r.ok ? r.json() : []; })
        .catch(function () { return []; });
    });
    return Promise.all(requests).then(function (results) {
      var dates = [];
      results.forEach(function (list) {
        (list || []).forEach(function (h) {
          if (!h || !h.date) return;
          // Nur echte, landesweite Feiertage übernehmen - die API liefert
          // sonst auch rein regionale Feiertage/Schulferien-Marker mit
          // (z. B. "Saint Rupert's Day", nur in Salzburg), die keine
          // tatsächlich landesweit arbeitsfreien Tage sind.
          if (h.nationalHoliday === true) {
            dates.push(h.date);
          }
        });
      });
      return dates;
    });
  }

  function refreshHolidaysFromApi() {
    var thisYear = new Date().getFullYear();
    Promise.all([fetchHolidaysForYear(thisYear), fetchHolidaysForYear(thisYear + 1)])
      .then(function (results) {
        var combined = results[0].concat(results[1]);
        if (combined.length === 0) return;
        var map = {};
        combined.forEach(function (d) { map[d] = true; });
        dynamicHolidays = map;
        saveCachedHolidays(combined);
        renderAll();
        syncCartAttribute();
      })
      .catch(function (err) {
        console.error('cf-estimated-delivery: Feiertage konnten nicht geladen werden, nutze Fallback-Liste', err);
      });
  }

  function initHolidays() {
    var cached = loadCachedHolidays();
    if (cached) {
      var map = {};
      cached.forEach(function (d) { map[d] = true; });
      dynamicHolidays = map;
    } else {
      dynamicHolidays = null; // sofort auf den (länder-gefilterten) Fallback zurückfallen
      refreshHolidaysFromApi();
    }
  }

  var DAY_ABBR_TO_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function parseDayList(str) {
    if (!str) return null;
    var days = str.split(',')
      .map(function (s) { return DAY_ABBR_TO_INDEX[s.trim()]; })
      .filter(function (n) { return n !== undefined; });
    return days.length ? days : null;
  }

  function applySettings(settings) {
    if (!settings) return;
    if (settings.message) CF_CONFIG.messageTemplate = settings.message;
    if (settings.cartMessage) CF_CONFIG.cartMessageTemplate = settings.cartMessage;
    if (settings.readyMin != null) CF_CONFIG.readyRange.min = Number(settings.readyMin);
    if (settings.readyMax != null) CF_CONFIG.readyRange.max = Number(settings.readyMax);
    if (settings.deliveryMin != null) CF_CONFIG.deliveryRange.min = Number(settings.deliveryMin);
    if (settings.deliveryMax != null) CF_CONFIG.deliveryRange.max = Number(settings.deliveryMax);
    if (settings.cutoffHour != null) CF_CONFIG.cutoffHour = Number(settings.cutoffHour);
    if (settings.cutoffMinute != null) CF_CONFIG.cutoffMinute = Number(settings.cutoffMinute);
    if (settings.cutoffEnabled != null) CF_CONFIG.cutoffEnabled = !!settings.cutoffEnabled;
    if (settings.dateFormat) CF_CONFIG.dateFormat = settings.dateFormat;

    var readyDays = parseDayList(settings.readyDays);
    if (readyDays) CF_CONFIG.readyWorkingDays = readyDays;

    var deliveryDays = parseDayList(settings.deliveryDays);
    if (deliveryDays) CF_CONFIG.deliveryWorkingDays = deliveryDays;

    if (settings.holidayCountries) {
      var countries = settings.holidayCountries.split(',')
        .map(function (s) { return s.trim().toUpperCase(); })
        .filter(Boolean);
      if (countries.length) CF_HOLIDAY_SOURCE.countries = countries;
    }
  }

  function loadAndApplySettings() {
    var settings = window.CF_ESTIMATED_DELIVERY_SETTINGS;
    if (settings) {
      applySettings(settings);
      try {
        localStorage.setItem('cf_delivery_settings_v1', JSON.stringify(settings));
      } catch (e) {
      }
    } else {
      try {
        var cached = localStorage.getItem('cf_delivery_settings_v1');
        if (cached) applySettings(JSON.parse(cached));
      } catch (e) {
      }
    }
  }

  function isHoliday(date) {
    var iso = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
    if (dynamicHolidays) {
      return !!dynamicHolidays[iso];
    }
    var mmdd = pad(date.getMonth() + 1) + '-' + pad(date.getDate());
    var fixedHit = CF_CONFIG.holidays.some(function (h) {
      return h.date === mmdd && h.countries.some(function (c) {
        return CF_HOLIDAY_SOURCE.countries.indexOf(c) !== -1;
      });
    });
    if (fixedHit) return true;
    return movableHolidaysForYear(date.getFullYear()).some(function (h) {
      return h.date === iso && h.countries.some(function (c) {
        return CF_HOLIDAY_SOURCE.countries.indexOf(c) !== -1;
      });
    });
  }

  function addWorkingDays(startDate, days, workingDaySet) {
    var d = new Date(startDate.getTime());
    var remaining = days;
    while (remaining > 0) {
      d.setDate(d.getDate() + 1);
      if (workingDaySet.indexOf(d.getDay()) !== -1 && !isHoliday(d)) {
        remaining--;
      }
    }
    return d;
  }

  function formatDate(d) {
    return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear();
  }

  function formatDayMonth(d) {
    return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.';
  }

  function formatDayMonthName(d) {
    return pad(d.getDate()) + '. ' + MONTHS_LONG[d.getMonth()];
  }

  // Formatiert das Datumspaar (min/max) passend zum gewählten dateFormat.
  // 'numeric' (Standard) verhält sich exakt wie bisher (formatDate für beide).
  function formatRangeDates(range) {
    var min = range.min;
    var max = range.max;
    switch (CF_CONFIG.dateFormat) {
      case 'weekday_long_short':
        return {
          min: WEEKDAYS_LONG[min.getDay()] + ', ' + formatDayMonth(min),
          max: WEEKDAYS_LONG[max.getDay()] + ', ' + formatDate(max)
        };
      case 'weekday_short_short':
        return {
          min: WEEKDAYS_SHORT[min.getDay()] + ', ' + formatDayMonth(min),
          max: WEEKDAYS_SHORT[max.getDay()] + ', ' + formatDate(max)
        };
      case 'weekday_long_full':
        return {
          min: WEEKDAYS_LONG[min.getDay()] + ', ' + formatDate(min),
          max: WEEKDAYS_LONG[max.getDay()] + ', ' + formatDate(max)
        };
      case 'weekday_short_full':
        return {
          min: WEEKDAYS_SHORT[min.getDay()] + ', ' + formatDate(min),
          max: WEEKDAYS_SHORT[max.getDay()] + ', ' + formatDate(max)
        };
      case 'weekday_long_monthname':
        return {
          min: WEEKDAYS_LONG[min.getDay()] + ', ' + formatDayMonthName(min),
          max: WEEKDAYS_LONG[max.getDay()] + ', ' + formatDayMonthName(max)
        };
      case 'weekday_short_monthname':
        return {
          min: WEEKDAYS_SHORT[min.getDay()] + ', ' + formatDayMonthName(min),
          max: WEEKDAYS_SHORT[max.getDay()] + ', ' + formatDayMonthName(max)
        };
      default:
        return { min: formatDate(min), max: formatDate(max) };
    }
  }

  function computeRange() {
    var now = new Date();
    var orderBase = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    var cutoff = new Date(orderBase.getTime());
    cutoff.setHours(CF_CONFIG.cutoffHour, CF_CONFIG.cutoffMinute, 0, 0);
    if (CF_CONFIG.cutoffEnabled && now > cutoff) {
      orderBase.setDate(orderBase.getDate() + 1);
    }

    var readyMax = addWorkingDays(orderBase, CF_CONFIG.readyRange.max, CF_CONFIG.readyWorkingDays);
    var anchor = CF_CONFIG.calculationMode === 'maxPreparation' ? readyMax : orderBase;

    return {
      min: addWorkingDays(anchor, CF_CONFIG.deliveryRange.min, CF_CONFIG.deliveryWorkingDays),
      max: addWorkingDays(anchor, CF_CONFIG.deliveryRange.max, CF_CONFIG.deliveryWorkingDays)
    };
  }

  function rangeText() {
    var range = computeRange();
    var formatted = formatRangeDates(range);
    return formatted.min + ' - ' + formatted.max;
  }

  function renderMessage(elementId, template) {
    var el = document.getElementById(elementId);
    if (!el) return;
    var range = computeRange();
    var formatted = formatRangeDates(range);
    var tpl = template || CF_CONFIG.messageTemplate;
    var html = tpl
      .replace('{min}', formatted.min)
      .replace('{max}', formatted.max);
    if (el.innerHTML !== html) {
      el.innerHTML = html;
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  // Merkt sich den zuletzt bekannten Rabatt-HTML-Stand - im Arbeitsspeicher
  // für sofortige Wiederverwendung innerhalb derselben Seite, UND
  // zusätzlich in localStorage, damit er auch direkt nach einem Neuladen
  // der Seite (oder erneutem Öffnen des Drawers) sofort angezeigt wird,
  // statt kurz zu "laden", bis die frischen Daten von /cart.js da sind.
  var lastDiscountsHtml = null;
  var DISCOUNTS_CACHE_KEY = 'cf_cart_discounts_cache_v1';

  function loadPersistedDiscountsHtml() {
    try {
      var raw = localStorage.getItem(DISCOUNTS_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return typeof parsed.html === 'string' ? parsed.html : null;
    } catch (e) {
      return null;
    }
  }

  function savePersistedDiscountsHtml(html) {
    try {
      localStorage.setItem(DISCOUNTS_CACHE_KEY, JSON.stringify({ html: html, savedAt: Date.now() }));
    } catch (e) {
      // localStorage evtl. nicht verfügbar - kein Problem
    }
  }

  function applyCachedDiscountsSync() {
    if (lastDiscountsHtml === null) {
      lastDiscountsHtml = loadPersistedDiscountsHtml();
    }
    if (lastDiscountsHtml === null) return;
    var el = document.getElementById('cf-cart-discounts');
    if (el && el.innerHTML !== lastDiscountsHtml) {
      el.innerHTML = lastDiscountsHtml;
    }
  }

  // Bündelt & drosselt alle /cart.js-Abrufe auf höchstens einen alle
  // 1.5 Sekunden, und fasst mehrere gleichzeitige Aufrufe zu einem
  // einzigen Request zusammen. Verhindert, dass häufige DOM-Änderungen
  // anderer Skripte (z. B. Countdown-Timer, die jede Sekunde ticken)
  // eine Lawine von /cart.js-Anfragen auslösen.
  var CART_FETCH_THROTTLE_MS = 1500;
  var lastCartFetchAt = 0;
  var pendingCartFetch = null;

  function throttledCartFetch() {
    if (pendingCartFetch) return pendingCartFetch;
    var wait = Math.max(0, lastCartFetchAt + CART_FETCH_THROTTLE_MS - Date.now());
    pendingCartFetch = new Promise(function (resolve) { setTimeout(resolve, wait); })
      .then(function () {
        lastCartFetchAt = Date.now();
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .finally(function () {
        pendingCartFetch = null;
      });
    return pendingCartFetch;
  }

  function renderCartDiscounts() {
    applyCachedDiscountsSync();
    if (!document.getElementById('cf-cart-discounts')) return;
    throttledCartFetch()
      .then(function (cart) {
        var discounts = cart.cart_level_discount_applications || [];
        var html = '';
        if (discounts.length) {
          var currency = cart.currency || 'EUR';
          var iconHtml = '<img src="https://cdn.shopify.com/s/files/1/0693/2856/8606/files/discount.svg?v=1747675398"' +
            ' alt="" style="width:1.2rem;height:1.2rem;vertical-align:middle;margin-right:0.4rem;">';
          html = '<ul class="discounts list-unstyled" role="list">' +
            discounts.map(function (d) {
              var amount;
              try {
                amount = new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency })
                  .format((d.total_allocated_amount || 0) / 100);
              } catch (e) {
                amount = ((d.total_allocated_amount || 0) / 100).toFixed(2) + ' ' + currency;
              }
              return '<li class="discounts__discount discounts__discount--end">' +
                iconHtml + escapeHtml(d.title) + ' (-' + amount + ')</li>';
            }).join('') +
            '</ul>';
        }
        lastDiscountsHtml = html;
        savePersistedDiscountsHtml(html);
        var el = document.getElementById('cf-cart-discounts');
        if (el && el.innerHTML !== html) {
          el.innerHTML = html;
        }
      })
      .catch(function () {
        // stiller Fehlschlag - lieber die letzte bekannte Anzeige behalten
      });
  }

  function syncCartAttribute() {
    var value = rangeText();
    throttledCartFetch()
      .then(function (cart) {
        if (cart.attributes && cart.attributes[CF_CONFIG.cartAttributeKey] === value) {
          return;
        }
        var attributes = {};
        for (var key in cart.attributes) {
          if (cart.attributes.hasOwnProperty(key)) attributes[key] = cart.attributes[key];
        }
        attributes[CF_CONFIG.cartAttributeKey] = value;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function (err) {
        console.error('cf-estimated-delivery: Cart-Attribut konnte nicht gesetzt werden', err);
      });
  }

  // Lädt den kompletten Warenkorb-Footer serverseitig frisch nach (genau
  // wie Dawn es selbst bei Mengenänderung/Hinzufügen tut) und füllt danach
  // unsere eigenen Bereiche wieder auf. Nötig, weil ein extern (z. B. per
  // iframe-Navigation zu /discount/CODE) angewendeter Rabattcode sonst nie
  // automatisch in der Warenkorb-Anzeige ankommt, solange der Kunde nicht
  // ohnehin schon eine Menge ändert oder etwas hinzufügt.
  function forceCartRefresh() {
    fetch('/cart?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshFooter = doc.querySelector('.cart-drawer__footer');
        var currentFooter = document.querySelector('.cart-drawer__footer');
        if (freshFooter && currentFooter) {
          currentFooter.replaceWith(freshFooter);
        }
        lastDiscountsHtml = null;
        renderAll();
      })
      .catch(function () {});
  }

  // Erkennt, wenn der Warenkorb-Drawer tatsächlich geöffnet wird (Dawn
  // setzt dabei die Klasse "active" am <cart-drawer>-Element), und stößt
  // in genau diesem Moment einen frischen Datenabgleich an.
  function watchCartDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var wasActive = drawer.classList.contains('active');
    var observer = new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) {
        forceCartRefresh();
      }
      wasActive = isActive;
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function watchForDomChanges() {
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        renderAll();
      });
    });
    var target = document.querySelector('cart-drawer') || document.body;
    observer.observe(target, { childList: true, subtree: true });
  }

  window.CFEstimatedDelivery = {
    renderMessage: renderMessage,
    rangeText: rangeText,
    syncCartAttribute: syncCartAttribute,
    debugConfig: function () {
      return {
        cutoffEnabled: CF_CONFIG.cutoffEnabled,
        cutoffHour: CF_CONFIG.cutoffHour,
        cutoffMinute: CF_CONFIG.cutoffMinute,
        readyRange: CF_CONFIG.readyRange,
        deliveryRange: CF_CONFIG.deliveryRange,
        readyWorkingDays: CF_CONFIG.readyWorkingDays,
        deliveryWorkingDays: CF_CONFIG.deliveryWorkingDays
      };
    }
  };

  function renderAll() {
    renderMessage('cf-estimated-delivery');
    renderMessage('cf-estimated-delivery-cart', CF_CONFIG.cartMessageTemplate);
    renderCartDiscounts();
  }

  function init() {
    loadAndApplySettings();
    initHolidays();

    renderAll();
    syncCartAttribute();
    watchForDomChanges();
    watchCartDrawerOpen();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        renderAll();
        syncCartAttribute();
      });
    }

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        loadAndApplySettings();
        initHolidays();
        renderAll();
        syncCartAttribute();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window);